module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Title tags recommended by ChatGPT","metaDescription":"Meta description tags recommended by ChatGPT"},"fr":{"title":"Balises Title recommandées par ChatGPT","metaDescription":"Balises Méta-description recommandées par ChatGPT"},"de":{"title":"Von ChatGPT empfohlener title-tag","metaDescription":"Von ChatGPT empfohlener meta description-tag"}}')
  delete Component.options._Ctor
}
